import Input from "../../controls/Input";

export default function WorkOrderInput(props) {
  const { name, title, handleInputChange, value } = props;
  return (
    <div className="flex justify-between">
      <p className="text-md font-bold">{title}</p>{" "}
      <Input
        label={title}
        name={name}
        onChange={handleInputChange}
        value={value}
        labelOn={false}
        type="text"
        className="mt-1 block w-16 border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
      />
    </div>
  );
}
